import { Injectable } from '@angular/core';
import { User } from '../classes/user';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APIService } from './api.service';

@Injectable()
export class UserService extends APIService {
  constructor(private http: HttpClient) { super(); }

  public getUser(): Observable<User> {
    return this.http.get<User>(`${this._baseUrl}/v1/breeder/me`);
  }
}
